import classNames from 'classnames';


const Input = ({ ['data-testid']: dataTestId = 'input', id, name, type = 'text', disabled = false, placeholder, label, prefixIcon, variant = 'outlined', cancelIcon, handleOnCancel, handleOnChange, required, focusColor,prefixNumber, ...inputprops }) => {
	const inputClass = classNames({
		'DS__input-field': true,
		'DS__input-field--disabled': disabled,
		'DS__input-field--prefix': prefixIcon,
		'DS__input-field--filled': variant === 'filled',
		'DS__input-field--outlined': variant === 'outlined',
	});

	const value = inputprops.value;
	const hasValue = typeof value === 'string' && value?.length > 0;

	const customStyle = {
		'--focus-color': focusColor,
	};

	return (
		<div className={inputClass} style={customStyle}>
			{prefixIcon && <div className="DS__input-field__prefix">{prefixIcon}</div>}
			{label && (
				<label className="DS__input-field__label" htmlFor={name}>
					{required && <span className={disabled ? '' : 'DS__input-field__textDanger'}>* </span>}
					{label}
				</label>
			)}
			{prefixNumber && <div className="DS__input-field__prefix-number">{prefixNumber}</div>}
			<div className="DS__input-field__input">
				<input
					// className='non-bordered'
					id={id || name}
					name={name}
					type={type}
					placeholder={placeholder}
					disabled={disabled}
					data-testid={dataTestId}
					onChange={handleOnChange}
					{...inputprops}
				/>
				{hasValue ? (
					<div
						className="DS__input-field__cancel-icon"
						data-testid={`${dataTestId}-cancel`}
						onClick={() => {
							handleOnCancel && handleOnCancel();
						}}
					>
						{cancelIcon}
					</div>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

export default Input;
